<script>
  import { navigate } from "svelte-routing";
  import ArrowLink from "../Common/ArrowLink.svelte";
  import { browser, INCLUDE_SECTORS } from "../../stores";

  // props
  export let sector;
  export let small = false;
  export let browse = false;

  // derived
  const descriptionMax = small ? 90 : 107;
  const description =
    sector.description.length >= descriptionMax
      ? `${sector.description.substr(0, descriptionMax)}...`
      : sector.description;
  const href = INCLUDE_SECTORS
    ? `/reports/sectors/${sector.slug}`
    : `/reports/search?sectorIds=${sector.id}&sort=date`;

  // events
  const handleClick = () => {
    if (!INCLUDE_SECTORS || browser.name === "ie") {
      location = href;
    } else {
      navigate(href);
    }
  };
</script>

<a
  {href}
  on:click|preventDefault={() => handleClick()}
  class="sector-preview {small ? 'small' : ''}"
>
  {#if sector?.image?.length}
    {@html sector.image}
  {/if}
  <div class="text" style={browse ? "height: 100%; display: flex;" : ""}>
    {#if browse}
      <ArrowLink
        {href}
        routing={INCLUDE_SECTORS}
        text={sector.title}
        stretch={true}
      />
    {:else}
      <h5>{sector.title}</h5>
      <p>{description}</p>
      <div class="sector-preview-link">
        <ArrowLink {href} routing={INCLUDE_SECTORS} text="Find Out More" />
      </div>
    {/if}
  </div>
</a>

<style>
  .sector-preview {
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 10px 10px;
    color: #4a4a4a;
    background: #fff;
    cursor: pointer;

    display: flex;
    flex-direction: column;
  }
  .text {
    padding: 26px 32px;
  }
  h5 {
    font-family: "Segoe UI", sans-serif;
    font-weight: 500;
    color: #4a4a4a;
  }

  .sector-preview.small .text {
    padding: 20px 24px 24px;
  }
  @media screen and (max-width: 580px) {
    .sector-preview {
      box-shadow: none;
    }
    .text {
      padding: 10px 0;
    }
    .text :global(a) {
      font-size: 20px;
      line-height: 30px;
    }
    .text :global(a svg) {
      display: none;
    }
  }
</style>
